import { combineReducers } from 'redux';
import database from './database'
import ui from './ui'
import { snackbarReducer as snackbar } from 'react-redux-snackbar'

export default combineReducers({
    database,
    ui,
    snackbar
})



// WEBPACK FOOTER //
// ./src/reducers/index.js